import React from 'react';
import cn from 'classnames';

import Link from 'gatsby-link';

import head from 'lodash/head';

import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {
    marginTop: 5,
    fontFamily: 'Raleway',
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 1.25,
    color: '#2b2a29',
  },
  link: {
    textDecoration: 'none',
    color: '#6a27e8',
    marginLeft: 4,
    marginRight: 4,
  },
});

const Meta = ({ classes, author, categories, className }) => {
  const category = head(categories);

  return (
    <div className={cn(classes.root, { [className]: !!className })}>
      <span>by</span>
      <Link to={`/blog/author/${author.slug}`} className={classes.link}>
        {author.name}
      </Link>
      <span>in</span>
      <Link to={`/blog/category/${category.slug}`} className={classes.link}>
        {category.name}
      </Link>
    </div>
  );
};

export default withStyles(styles)(Meta);
